<template>
    <div class="container-fluid p-0">
        <span v-if="!loading">
            <b-row>
                <b-row class="m-md-3 container-fluid">
                    <b-card-header header-bg-variant="primary" header-text-variant="light"
                                   class="rounded m-md-3 container-fluid">
                        {{ $t('settings.device_parameters') }}
                    </b-card-header>
                </b-row>
                <b-row class="m-md-3 container-fluid">
                    <b-col class="ml-3">{{ $t('settings.configuration.version_update_time') }}: {{firmwareCurrentUpdateTime}}</b-col>
                </b-row>
                <b-row class="m-md-3 container-fluid">
                    <b-col class="ml-3">
                        <b-form @submit.prevent="saveConfig">
                        <label class="mr-sm-2" for="device_configuration">{{$t('device_group_actions.set_configuration')}}</label>
                        <b-form-select
                            id="device_configuration"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :value="null"
                            v-model="configurationId"
                            :options="configurationList"
                            value-field="id"
                            text-field="name"
                        ></b-form-select>

                        <div v-if="saveConfigSuccess" class="text-success">
                          {{$t('saved_success')}} <br>
                        </div>
                        <div v-if="saveConfigError" class="text-danger">
                          {{$t('saved_error')}} <br>
                        </div>

                        <b-button
                            :disabled="configurationId === null"
                            class="mt-2"
                            type="submit"
                            variant="primary"
                        >{{$t('save')}}</b-button>
                    </b-form>
                    </b-col>
                </b-row>
            </b-row>
            <b-row>
                <b-row class="m-md-3 container-fluid">
                    <b-card-header header-bg-variant="primary" header-text-variant="light"
                                   class="rounded m-md-3 container-fluid">
                        {{ $t('create_configuration') }}
                    </b-card-header>
                </b-row>
                <b-row class="m-md-3 container-fluid">
                    <b-col class="ml-3">
                        <b-form @submit.prevent="saveConfigByDeviceId" >
                            <b-form-group
                                id="input-group-name"
                                :label="$t('device_configuration.create.name') + ':'"
                                label-for="input-name"
                                description=""
                            >
                                <b-form-input
                                    id="input-name"
                                    v-model="newTemplateData.name"
                                    required
                                    placeholder=""
                                ></b-form-input>
                            </b-form-group>
                            <b-form-group
                                :label="$t('device_configuration.create.description') + ':'"
                                label-for="input-description"
                                description=""
                            >
                                <b-form-input
                                    id="input-description"
                                    v-model="newTemplateData.description"
                                    required
                                    placeholder=""
                                ></b-form-input>
                            </b-form-group>

                            <div v-if="saveConfigAsSuccess" class="text-success">
                                {{$t('saved_success')}} <br>
                            </div>
                            <div v-if="saveConfigAsError" class="text-danger">
                              {{$t('saved_error')}} <br>
                            </div>

                            <div>
                                {{$t('device_configuration_save_notice')}} <br>
                            </div>

                            <b-button type="submit" variant="primary">{{$t('device_configuration.create.create')}}</b-button>
                        </b-form>
                    </b-col>
                </b-row>
            </b-row>
        </span>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "Configuration",
    props: {
        id: {
            type: Number
        }
    },
    data() {
        return {
            device: {},
            showSuccessAlert: false,
            loading: true,
            firmwareCurrent: null,
            firmwareId: null,
            configurationId: null,
            firmwareList: [],
            configurationList: [],
            saveConfigSuccess: false,
            saveConfigError: false,
            saveConfigAsSuccess: false,
            saveConfigAsError: false,
            saveFirmwareSuccess: false,
            saveFirmwareError: false,
            templateName: null,
            newTemplateData: {
                description: null,
                name: null
            }
        }
    },
    watch: {
        configurationId: function() {
            this.saveConfigSuccess = false;
            this.saveConfigError = false;
        },
        firmwareId: function() {
            this.saveFirmwareSuccess = false;
            this.saveFirmwareError = false;
        },
        newTemplateData: function () {
            this.saveConfigAsSuccess = false;
            this.saveConfigAsError = false;
        },
    },
    mounted() {
        let props = this;
        axios
            .get('api/v1/devices/' + props.id)
            .then((data) => {
                this.device = data.data;

                this.firmwareCurrent = this.device.firmware.id;
                this.firmwareCurrentUpdateTime = this.device.configuration.updateTime;

                // this.loadFirmwareList(this.device.typeId);
                this.loadConfigurationList(this.device.typeId);

                this.loading = false;
            })
            .catch(() => undefined);
    },
    methods: {
        loadFirmwareList(deviceType) {
            axios
                .get('api/v1/firmwares/device-type/' + deviceType)
                .then((data) => {
                    this.firmwareList = [
                        {
                            id: null,
                            version: this.$t('select_firmware')
                        }
                    ]

                    this.firmwareList = this.firmwareList.concat(data.data.rows)
                })
                .catch(() => undefined);
        },
        loadConfigurationList(deviceType) {
            axios
                .get('api/v1/configurations/device-type/' + deviceType)
                .then((data) => {
                    this.configurationList = [
                        {
                            id: null,
                            name: this.$t('select_configuration')
                        }
                    ]

                    this.configurationList = this.configurationList.concat(data.data.rows)
                })
                .catch(() => undefined);
        },
        saveFirmware() {
            axios
                .post('api/v1/devices/' + this.id + '/savedConfig/' + this.configurationId)
                .then(() => {
                    // console.log(response);
                    this.saveFirmwareSuccess = true
                    this.$emit('device:changed')
                })
                .catch(error => {

                    console.log(error);
                    this.saveFirmwareError = true
                })
        },
        saveConfig() {
            axios
                .post('api/v1/devices/' + this.id + '/savedConfig/' + this.configurationId)
                .then(() => {
                    // console.log(response);
                    this.saveConfigSuccess = true
                    this.$emit('device:changed')
                })
                .catch(error => {

                    console.log(error);
                    this.saveConfigError = true;
                })
        },
        saveConfigByDeviceId() {
            this.isBusy = true;

            axios
                .post(
                    'api/v1/saved-configurations/new/device/' + this.id,
                    {
                        name: this.newTemplateData.name,
                        description: this.newTemplateData.description,
                    },
                    {
                        headers: {
                            'Content-type': 'application/json',
                        }
                    }
                )
                .then(() => {
                    this.saveConfigAsSuccess = true;
                    this.saveConfigAsError = false;

                    this.newTemplateData.name = null;
                    this.newTemplateData.description = null;

                    this.loadConfigurationList(this.device.typeId);
                    // router.push({ name: 'savedConfiguration', params: { id: data.data.id } })
                })
                .catch(() => {

                    this.saveConfigAsSuccess = false;
                    this.saveConfigAsError = true;
                });
        }
    }
}
</script>

<style scoped>

</style>